import React from 'react';
const cities = [{
  name: 'Orlando',
  x: 380,
  y: 205,
  primary: true,
  labelDx: 20,
  labelDy: 7,
  anchor: 'start' as const
}, {
  name: 'Winter Garden',
  x: 250,
  y: 200,
  primary: false,
  labelDx: -10,
  labelDy: -16,
  anchor: 'end' as const
}, {
  name: 'Clermont',
  x: 135,
  y: 250,
  primary: false,
  labelDx: 0,
  labelDy: 30,
  anchor: 'middle' as const
}, {
  name: 'Kissimmee',
  x: 365,
  y: 345,
  primary: false,
  labelDx: 16,
  labelDy: 5,
  anchor: 'start' as const
}];
export function ServiceAreaMap() {
  return <svg viewBox="0 0 600 480" className="h-full w-full" role="img" aria-label="Simplified map of the Innova service area covering Orlando, Winter Garden, Clermont, and Kissimmee" data-id="element-260" data-mp="9i6wegrs7w38">
      {/* Service region */}
      <circle cx="290" cy="255" r="215" fill="#17BBD5" fillOpacity="0.06" stroke="#17BBD5" strokeOpacity="0.55" strokeWidth="2" strokeDasharray="6 8" data-id="element-261" data-mp="3vrhjzgxm4rtf" />
      <circle cx="290" cy="255" r="135" fill="#17BBD5" fillOpacity="0.06" data-id="element-262" data-mp="1txs5p33ydhvx" />

      {/* Lakes */}
      <g fill="#17BBD5" fillOpacity="0.28" data-id="element-263" data-mp="21ztuc2695lwr">
        <ellipse cx="215" cy="110" rx="62" ry="40" data-id="element-264" data-mp="21z1ycq8qtm5y" />
        <ellipse cx="110" cy="205" rx="26" ry="18" data-id="element-265" data-mp="262ggpnk5memk" />
        <ellipse cx="300" cy="268" rx="18" ry="13" data-id="element-266" data-mp="2639ngoj4544p" />
        <ellipse cx="420" cy="420" rx="60" ry="36" data-id="element-267" data-mp="1s2yyjr1d5zm6" />
      </g>

      {/* I-4 */}
      <path d="M40 440 C 160 380, 260 320, 330 270 S 430 160, 580 60" fill="none" stroke="#FFFFFF" strokeOpacity="0.18" strokeWidth="5" strokeLinecap="round" data-id="element-268" data-mp="1x10fa5bbhmuh" />
      <text x="526" y="112" fontSize="12" fontWeight="700" fontFamily="Inter, sans-serif" fill="#FFFFFF" fillOpacity="0.5" data-id="element-269" data-mp="2krmmjudhz33f">
        I-4
      </text>

      {/* Cities */}
      {cities.map(c => <g key={c.name} data-id="element-270" data-mp="2b0rrc0i9wt5u">
          {c.primary && <circle cx={c.x} cy={c.y} r="28" fill="#17BBD5" fillOpacity="0.25" data-id="element-271" data-mp="2fzusvaz1oh92" />}
          <circle cx={c.x} cy={c.y} r={c.primary ? 11 : 7} fill={c.primary ? '#17BBD5' : '#FFFFFF'} stroke="#063765" strokeWidth="3" data-id="element-272" data-mp="2fxrzcgyoo5zl" />
          <text x={c.x + c.labelDx} y={c.y + c.labelDy} textAnchor={c.anchor} fontFamily="'Plus Jakarta Sans', Inter, sans-serif" fontSize={c.primary ? 22 : 15} fontWeight={c.primary ? 800 : 700} fill="#FFFFFF" data-id="element-273" data-mp="38gp2mxshgnvt">
            {c.name}
          </text>
        </g>)}
    </svg>;
}